module.exports = __webpack_public_path__ + "static/sacred-moment-4121dbcceae8ad23e7c1c2016c4ad896.jpg";